export default "__VITE_ASSET__Dh01_FQP__"